import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 400px;
  border-radius: 12px;
  background-color: #ffffff;
`;

export const Spinner = styled.div`
  width: 42px;
  height: 42px;
  border: 5px solid #a0a0a0;
  border-top: 5px solid #049366;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
